__turbopack_context__.v({
  "body": "style-module-scss-module__DzWRxG__body",
  "container": "style-module-scss-module__DzWRxG__container",
  "description": "style-module-scss-module__DzWRxG__description",
  "socialBlock": "style-module-scss-module__DzWRxG__socialBlock",
  "socialBlock__disabled": "style-module-scss-module__DzWRxG__socialBlock__disabled",
  "socialBlock__icon": "style-module-scss-module__DzWRxG__socialBlock__icon",
  "socialBlock__icons": "style-module-scss-module__DzWRxG__socialBlock__icons",
  "socialBlock__text": "style-module-scss-module__DzWRxG__socialBlock__text",
  "text": "style-module-scss-module__DzWRxG__text",
  "title": "style-module-scss-module__DzWRxG__title",
});
